/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProjectDetailsTypeResource } from './';
import {
    ProjectDetailsTypeResourceFromJSON,
    ProjectDetailsTypeResourceFromJSONTyped,
    ProjectDetailsTypeResourceToJSON,
} from './';
import type { RecurringProjectDetailsRequest } from './';
import {
    RecurringProjectDetailsRequestFromJSON,
    RecurringProjectDetailsRequestFromJSONTyped,
    RecurringProjectDetailsRequestToJSON,
} from './';
import type { ShortProjectDetailsRequest } from './';
import {
    ShortProjectDetailsRequestFromJSON,
    ShortProjectDetailsRequestFromJSONTyped,
    ShortProjectDetailsRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectDetailsRequest
 */
export interface ProjectDetailsRequest {
    /**
     * 
     * @type {ProjectDetailsTypeResource}
     * @memberof ProjectDetailsRequest
     */
    type: ProjectDetailsTypeResource;
    /**
     * 
     * @type {Date}
     * @memberof ProjectDetailsRequest
     */
    startDate: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectDetailsRequest
     */
    hideFreelancerDailyRate: boolean;
}

/**
 * Check if a given object implements the ProjectDetailsRequest interface.
 */
export function instanceOfProjectDetailsRequest(value: object): value is ProjectDetailsRequest {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('hideFreelancerDailyRate' in value) || value['hideFreelancerDailyRate'] === undefined) return false;
    return true;
}

export function ProjectDetailsRequestFromJSON(json: any): ProjectDetailsRequest {
    return ProjectDetailsRequestFromJSONTyped(json, false);
}

export function ProjectDetailsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDetailsRequest {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['type'] === 'RECURRING') {
            return RecurringProjectDetailsRequestFromJSONTyped(json, true);
        }
        if (json['type'] === 'SHORT') {
            return ShortProjectDetailsRequestFromJSONTyped(json, true);
        }
    }
    return {
        
        'type': ProjectDetailsTypeResourceFromJSON(json['type']),
        'startDate': (new Date(json['startDate'])),
        'hideFreelancerDailyRate': json['hideFreelancerDailyRate'],
    };
}

export function ProjectDetailsRequestToJSON(value?: ProjectDetailsRequest | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
        if (value.type === 'RECURRING') {
            return RecurringProjectDetailsRequestToJSON(value as RecurringProjectDetailsRequest);
        }
        if (value.type === 'SHORT') {
            return ShortProjectDetailsRequestToJSON(value as ShortProjectDetailsRequest);
        }
    }
    return {
        
        'type': ProjectDetailsTypeResourceToJSON(value['type']),
        'startDate': ((value['startDate']).toISOString().substring(0,10)),
        'hideFreelancerDailyRate': value['hideFreelancerDailyRate'],
    };
}

